<template>
  <div class="home w100_ ">
    <div v-if="!isQiankun" class="header w100_ align-i-c display-f p024 borderBox just-c">
      <div class="header-row w100_">
        <div class="display-f align-i-c">
          <div class="header-avatar mr12"><el-avatar size="medium" :src="imgArr.logo"></el-avatar></div>
          <el-select class="deptName" v-model="deptId" @change="changeDept">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div>
        <div class="menu display-f just-c" :class="{ 'smallPadding': smallPadding }">
          <el-menu mode="horizontal" :default-active="curActive" background-color="transparent"
            text-color="rgba(255, 255, 255, .8)" unique-opened active-text-color="#fff" router>
            <template v-for="(menu, i) in menus" v-if="!menu.hidden">
              <!-- 无下拉 -->
              <el-menu-item v-if="!menu.children" :index="menu.path" :key="i" class="menu_one_item">
                <i class="iconfont" :class="menu.meta.icon"></i>
                <span slot="title">{{ menu.meta.title }}</span>
              </el-menu-item>
              <!-- 下拉 -->
              <el-submenu v-else :index="menu.path" :key="i" class="">
                <template slot="title">
                  <div>
                    <!-- <i class="iconfont" :class="menu.meta.icon"></i> -->
                    <span>{{ menu.meta.title }}</span>
                  </div>
                </template>
                <el-menu-item v-for="item in menu.children" :key="item.path" :index="item.path" v-show="!item.hidden"
                  class="menu-item ">
                  <!-- <i class="iconfont" :class="item.meta.icon"></i> -->
                  <span class="size15">
                    {{ item.meta.title }}
                  </span>

                  <span style="position: relative; top: -2px;" v-if="item.meta.title == '拍单接单' && newOrderNum > 0">({{
                    newOrderNum }})</span>
                  <span style="position: relative; top: -2px;" v-if="item.meta.title == '网诊接诊' && newWebChatNum > 0">({{
                    newWebChatNum }})</span>
                </el-menu-item>
              </el-submenu>
            </template>
          </el-menu>
        </div>
        <div class="user-detail">
          <div class="avatar display-f align-i-c just-fe">
            <el-badge class="notification_badge" :value="noticeMap.unreadCount" :max="10" :hidden="noticeMap.unreadCount === 0">
              <span class="el-icon-bell notification_icon" @click="toNotificationBoard"></span>
            </el-badge>
            <el-avatar size="small" class="mr12" :src="userInfo.avatar" />
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link cFFF">
                {{ userInfo.nickName }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="personnal">个人中心</el-dropdown-item>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                <el-dropdown-item command="passwordmodify">修改密码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>

    </div>
    <div class="content" :style="isQiankun ? 'margin: 0 0 0 0;' : ''">
      <router-view />
    </div>
    <noticePopover ref="noticePopover"></noticePopover>
  </div>
</template>

<script lang="js">
import Bus from '@/utils/bus'; // 中央事件总线
import axios from 'axios'; // 引入axios
import { isNull } from '@/utils/validateBase';
import customDialog from '../components/customDialog'
import noticePopover from '../components/notice/noticePopover'
import { versionList } from '@/config/version'
import { imgArr } from '@/assets/images/img';
import { deptDTO } from '@/DTO/index'
import req from '@/utils/request'
export default {
  data() {
    return {
      isQiankun: window.__POWERED_BY_QIANKUN__,
      imgArr: imgArr,
      avatar: require('@/assets/images/logo.png'),
      menus: this.$session.get('menuList'), // 菜单
      userInfo: { userName: null, avatar: null }, // 用户信息
      options: [], // 医馆选项
      deptId: null, // 医馆id
      wsTakeOrder: this.$store.state.wsTakeOrder, // websocket拍单链接
      wsWebchat: this.$store.state.wsWebchat, // websocket网诊链接
      // disconnectTimer: null, // 断开 重连定时器
      breadArr: null, // 面包屑导航列表
      newOrderNum: 0, // 新拍单订单数量
      newWebChatNum: 0, // 新网诊订单数量
      doctorId: null, // 登录医生id
      smallPadding: false,//更小的宽度
      noticeSSESource: null, // 公告SSE连接
    };
  },
  components: { customDialog, noticePopover },
  computed: {
    // 导航激活
    curActive() {
      let path = this.$route.path;
      if (path === "/home") return "/";
      else if (path == '/doctorworkstation/diagnosis') return this.$session.get('href');
      else if (path.indexOf('details') != -1 && path.indexOf('statement') == -1) return path.substr(0, path.length - 7) + 'list';
      return path;
    },
    noticeMap () {
      return this.$store.state.noticeMap
    }
  },
  created() {
    this.getOptions(); // 获取医馆列表
    this.isTakeOrders(); // 判断是否拍单
    this.isWebChatDoctor(); // 判断是否网诊
    this.isPricing(); // 判断是否划价
    this.getPopUpNotice()
    this.$store.dispatch('getNoticeNum')

    this.initNoticeSSE()
    //监听页面变化
    let that = this
    that.getClientWidth()
    window.addEventListener('resize', _.debounce(that.getClientWidth, 150));
  },
  mounted() {
    // 拍单数量改变
    Bus.$on('newOrderNumBack', res => { this.newOrderNum = res });
    // 网诊数量改变
    Bus.$on('newWebChatNumBack', res => { this.newWebChatNum = res });
  },
  watch: { // 监听路由变化
    "$route.path"() {
      this.calcBreadArr();
    },
  },
  beforeDestroy () {
    if (this.noticeSSESource) {
      this.closeNoticeSSE()
    }
  },
  methods: {
    //计算页面宽度变化
    getClientWidth() {
      const availableWidth = document.body.clientWidth; // 获取浏览器窗口的可用宽度
      if (availableWidth < 1366) {
        this.smallPadding = true
      } else {
        this.smallPadding = false
      }
    },
    // 获取医馆列表
    getOptions() {
      let options = this.$session.get("options");
      this.options = options;
      this.$session.set("options", options);
      this.deptId = this.$session.get("deptId");
      let user = this.$session.get("user");
      user.avatar == "" ? user.avatar = imgArr.static : user.avatar = user.avatar;
      this.userInfo = user;
      this.calcBreadArr();
    },
    // 面包屑导航
    calcBreadArr() {
      // let arr = [{ path: "/home", title: "主页" }];
      let arr = [];
      if (this.$route.path != '/404' && this.$route.path != '/notificationBoard') {
        this.$route.matched.forEach(item => {
          if (item.meta && item.meta.title) arr.push({ path: item.path, title: item.meta.title });
        });
        this.menus.forEach(item => {
          const routerPath = arr.length > 1 ? arr[1].path : arr[0].path
          if (item.path == routerPath) {
            let tempArr = [];
            item.children && item.children.forEach(kid => {
              if (kid.hidden == false) tempArr.push(kid);
            })
            if (tempArr.length > 0) {
              arr[1].path = tempArr[0].path;
            }
          }
        })
        this.breadArr = arr;
      }
    },
    // 切换医馆
    async changeDept(deptId) {
      let { code, data } = await deptDTO.switchAndGetDept({ deptId: deptId + '' })
      if (code == 200) {
        this.$session.set("deptId", data.deptId);
        this.$session.set("ybDeptNum", data.ybDeptNum);
        this.$session.set("deptInfo", data);
        window.location.reload();
      }
    },
    // 退出登录和修改密码
    handleCommand(command) {
      switch (command) {
        case 'passwordmodify':
          this.$router.push("/account/passwordmodify");
          break;
        case 'personnal':
          this.$router.push("/account/personal");
          break;

        case 'logout':
          this.$message.success("退出系统成功");
          this.$session.clear();
          this.$router.push({ path: '/login', replace: true });
          break;
      }
    },
    // 判断是否拍单
    isTakeOrders() {
      // 判断是否有拍单接单权限
      let takeOrderFlag = null;
      this.menus.forEach(item => {
        if (item.path == '/pricing') item.children.forEach(kid => {
          if (kid.path == '/pricing/onlinetaking') takeOrderFlag = true;
        });
      });
      // 有权限 连接拍单长链接，实时提醒新订单
      if (takeOrderFlag == true && this.deptId != null) {
        this.newOrderNum = this.$session.get('newOrderNum') || 0;
        this.$initWebSocketTakeOrder();
      };
    },
    // 判断是否是网诊医生
    isWebChatDoctor() {
      const userInfo = this.$session.get('user');
      if (userInfo.type == '0') {
        let isWebChat = userInfo.hospDoctorInfo.isWebChat;
        this.doctorId = userInfo.hospDoctorInfo.doctorId;
        if (isWebChat == '1') {
          // this.$initWebSocketWebChat();
          this.newWebChatNum = this.$session.get('newWebChatNum') || 0;
        }
      }
    },
    // 判断是否有划价权限
    isPricing() {
      // 判断是否有划价权限
      let pricingFlag = null;
      this.menus.forEach(item => {
        if (item.path == '/pricing') pricingFlag = true;
      });
      // 有权限 连接拍单长链接，实时提醒新订单
      // if (pricingFlag == true) {
      //   let shebaoSign = this.$session.get('shebaoSign');
      //   if (!shebaoSign) {
      //     axios({
      //       method: "post",
      //       url: this.$shebaoUrl,
      //       data: { requestType: 'YB', interfaceName: 'signIn', data: '' },
      //     }).then(res => {
      //       if (res.data.code == 200) this.$session.set('shebaoSign', true);
      //     });
      //   }
      // }
    },
    // 退医保脚本
    refundYB() {
      axios({
        method: "post",
        url: `${this.$shebaoUrl}/query_person_info`,
        data: { requestType: 'YB', interfaceName: 'init', data: '' },
      }).then(res => {
        if (res.data.code == 200) {
          let data = JSON.parse(JSON.stringify(res.data.data));
          let params = JSON.stringify({
            setl_id: '510100CD000451700758', // 结算ID
            mdtrt_id: '510100CD000304349903', // 就诊ID
            psn_no: data.baseinfo.psn_no, // 人员编号
            certno: data.baseinfo.certno, // 身份证
            insuplc_admdvs: data.insuinfo.filter(v => { return v.insutype == '310' })[0].insuplc_admdvs //就诊人员参保地医保区划
          });
          // 社保退款
          axios({
            method: "post",
            url: `${this.$shebaoUrl}/repeal_settlement`,
            data: params,
          }).then(res => {
            if (res.data.code == 200) this.$message.success('医保支付金额退款成功！');
          });
        }
      });
    },
    toNotificationBoard () {
      this.$router.push('/notificationBoard')
    },
    async getPopUpNotice () {
      const res = await req.get('/announcement/employee/login-popup', { mode: 'LATEST' })
      if (res.code == 200) {
        if (res.data.length > 0) {
          const notice = res.data[0]
          this.$refs.noticePopover.open(notice)
        }
      }
    },
    initNoticeSSE () {
      const url = `${process.env.VUE_APP_API_URL}/api/announcement/employee/events?Authorization=${JSON.parse(sessionStorage.getItem('t_k')) || null}`
      this.noticeSSESource = new EventSource(url)
      this.noticeSSESource.addEventListener('announcement-ready', (event) => {
        this.getPopUpNotice()
        this.$store.dispatch('getNoticeNum')
      })
      this.noticeSSESource.addEventListener('error', (error) => {
        console.error('SSE 连接错误:', error)
        this.closeNoticeSSE()
      })
    },
    closeNoticeSSE () {
      if (this.noticeSSESource) {
        this.noticeSSESource.close()
        this.noticeSSESource = null
      }
    }
  },
};
</script>

<style lang="less" scoped>
@minWidth: 1366px;
@maxWidth: 1640px;
@bgColor: #f5f5f5;

.home {
  background: @bgColor;
  // min-width: @minWidth;
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100%;

  .header {
    height: 48px;
    background: #093c7b;
    position: fixed;
    z-index: 999;
    top: 0;

    .header-row {
      max-width: @maxWidth;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .user-detail {
        color: #fff;

        .el-avatar {
          margin-left: 15px;
          background-color: #fff;
          border: 1px solid #ccc;
        }
      }

      .menu {
        /deep/.el-submenu__icon-arrow {
          display: none !important;
        }

        /deep/.el-submenu__title {
          border: 0 !important;
          font-size: 15px;
        }

        /deep/.el-menu {
          .el-submenu__title {
            background: transparent !important;
          }

          /deep/.el-menu--horizontal {
            border-bottom: 0 !important
          }
        }
      }

      .deptName {
        /deep/.el-input__inner {
          background: transparent;
          color: #fff;
          border: 0;
          width: 100px;
          padding: 0;
        }

        .header-avatar {
          /deep/.el-avatar--medium {
            width: 32px;
            height: 32px;
          }
        }

      }
    }
  }

  .content {
    width: 100%;
    height: 100%;
    // max-width: @maxWidth;
    margin: 48px auto 0;
    // padding: 16px 24px;
    padding: 0px 0px;
    flex: 1;
    box-sizing: border-box;
    overflow: hidden;
  }

}

/deep/.el-card {
  height: 100% !important;
}

/deep/.el-card__body {
  overflow: auto;
}

.menu-item {
  background: #fff !important;
  color: #1F2329 !important;
}

.menu-item:hover {
  background: #E8F4FF !important;
  color: #1890FF !important;
}

.smallPadding {
  /deep/.el-menu {
    .el-submenu__title {
      padding: 0px 16px;
    }
  }
}

.menu_one_item {
  font-size: 15px;
}

.menu_one_item:hover {
  background-color: transparent !important;
}

.notification_badge {
  margin: 0 16px 0 0;
}

.notification_icon {
  font-size: 20px;
  color: #FFFFFF;
  cursor: pointer;
}
</style>
